var map = {
	"./01_create_api.json": "+Rge",
	"./02_permission_set.json": "UG8z",
	"./03_request_content.json": "hS6o",
	"./04_sign_discription.json": "9KKA",
	"./05_request.json": "uSYo"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6wHN";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/authentication \.json$
// module id = 6wHN
// module chunks = 3